import * as React from 'react';
const SVGComponent = (props) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='m12 0 4 9 8 1-6 5 2 9-8-5-8 5 2-9-6-5 8-1z'
      fill={props.fill || '#e7711b'}
    />
    <path
      d='M12 0 8 9l-6.969.8L6 14l-.187.8L6 15l-1.75 7.8L12 18l7.75 4.8L18 15l.188-.2L18 14l4.969-4.2L16 9z'
      fill={props.fill || '#e7711b'}
    />
  </svg>
);
export default SVGComponent;
